import React from 'react'
import About from './about/About'
import Contacts from './contacts/Contacts'
import Hero from './hero/Hero'

const HomePage = () => {
  return (
    <>
        <Hero/>
        <About/>
        <Contacts/>
    </>
  )
}

export default HomePage